import { Roles } from 'utils/consts/userRoles'
import { databaseFiltersName } from 'utils/consts'
import type { FiltersCollection } from '../filtersCollectionsRegistry'
import type { DatabaseFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import { pickEntries } from './entries'

type Role = string

const geoIndicationFullOrder = [
  databaseFiltersName.countryFilter,
  databaseFiltersName.euGITypeFilter,
  databaseFiltersName.nationalGITypeFilter,
  databaseFiltersName.wineRegionEUFilter,
  databaseFiltersName.parentGeoIndicationFilter,
  databaseFiltersName.wineTerritoryTypeFilter,
]

export const getDatabaseGeoIndicationFiltersCollection = (
  role: Role
): FiltersCollection => {
  switch (role) {
    case Roles.CONTENT:
    case Roles.SUPERADMIN:
      return pickEntries(geoIndicationFullOrder)
    default:
      return []
  }
}

export const databaseGeoIndicationFiltersConfig: DatabaseFiltersConfig = {
  component: 'database',
  getFiltersCollection: getDatabaseGeoIndicationFiltersCollection,
  showResultsTextKey: 'filters.button.apply',
}
